module.exports = __webpack_public_path__ + "static/media/photo.79c9ff61.svg";